<template>
  <div>
    <AppHeader />
    <AppBody />
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "@/components/AppHeader";
import AppFooter from "@/components/AppFooter";
import AppBody from "@/components/AppBody";
export default {
  name: "Base",
  components: {AppBody, AppFooter, AppHeader}
}
</script>

<style scoped>

</style>
